var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie',{attrs:{"options":_vm.defaultOptions,"height":200,"width":200}})}
var staticRenderFns = []

export { render, staticRenderFns }